import { render, staticRenderFns } from "./orderMgtk.vue?vue&type=template&id=6e32f5a7&scoped=true&"
import script from "./orderMgtk.vue?vue&type=script&lang=js&"
export * from "./orderMgtk.vue?vue&type=script&lang=js&"
import style0 from "./orderMgtk.vue?vue&type=style&index=0&id=6e32f5a7&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6e32f5a7",
  null
  
)

export default component.exports